import { useState } from "react";
import { Link } from "react-router-dom";

function MediaFrame({ image, poster, video }) {
  const [status, setStatus] = useState(image ? "loading" : "empty");
  const showPoster = status !== "ready";

  return (
    <span className={`media-frame${showPoster ? ` media-poster media-poster-${poster}` : ""}`}>
      {image ? (
        <img
          src={image}
          alt=""
          className={status === "ready" ? undefined : "is-pending"}
          ref={(node) => {
            if (node?.complete) {
              setStatus(node.naturalWidth > 0 ? "ready" : "failed");
            }
          }}
          onLoad={() => setStatus("ready")}
          onError={() => setStatus("failed")}
        />
      ) : null}
      {image && status === "loading" ? <span className="media-spinner" aria-hidden="true" /> : null}
      {video ? <span className="media-play" aria-hidden="true" /> : null}
    </span>
  );
}

export default function MediaCard({
  href,
  image,
  kicker,
  title,
  action,
  poster = "plain",
  video = false,
}) {
  const className = "media-card";
  const body = (
    <>
      <MediaFrame key={image || "poster"} image={image} poster={poster} video={video} />
      <span className="media-copy">
        {kicker ? <span className="media-kicker">{kicker}</span> : null}
        {title ? <span className="media-title">{title}</span> : null}
        {action ? <span className="media-action">{action}</span> : null}
      </span>
    </>
  );

  if (!href) {
    return <div className={className}>{body}</div>;
  }

  if (href.startsWith("http")) {
    return (
      <a className={className} href={href} target="_blank" rel="noopener noreferrer">
        {body}
        <span className="sr-only"> (opens in a new tab)</span>
      </a>
    );
  }

  return (
    <Link className={className} to={href}>
      {body}
    </Link>
  );
}
